import React from "react";
import reduce from "lodash/reduce";
import { Subscribe } from "unstated";

export const withSubscribe = ({ to }) => (C) => (props) => {
  const mapping = reduce(
    to,
    (acc, container, key) => [...acc, { key, container }],
    []
  );
  const containerClasses = mapping.map((item) => item.container);
  const containersToProps = (containers) =>
    containers.reduce(
      (acc, container, index) => ({ ...acc, [mapping[index].key]: container }),
      {}
    );

  return (
    <Subscribe to={containerClasses}>
      {(...containers) => <C {...containersToProps(containers)} {...props} />}
    </Subscribe>
  );
};

export { Subscribe, Provider } from "unstated";
export { default as AuthContainer } from "./AuthContainer";
export { default as LayoutContainer } from "./LayoutContainer";
